exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--option__11vsU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:5px}.styles--radio__33_F6{margin-right:10px}.styles--pre__3dPCu{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.styles--answer__1gdLD{font-weight:600}\n", ""]);

// exports
exports.locals = {
	"option": "styles--option__11vsU",
	"radio": "styles--radio__33_F6",
	"pre": "styles--pre__3dPCu",
	"answer": "styles--answer__1gdLD"
};